/* eslint react/prop-types: 0 */
import React from 'react';
import { Link } from 'react-router-dom';
import * as flat from 'flat';

import ViewHelpers from '@/shared/ViewHelpers';

export default class List extends React.PureComponent {
  render() {
    const { property, record, resource } = this.props;
    const showAction = record.recordActions.find(a => a.name === 'show');
    const unflatten = flat.unflatten(record.params);
    const values = unflatten[property.name] || [];

    if (resource.titleProperty.name === property.name && showAction) {
      const h = new ViewHelpers();
      const href = h.recordActionUrl({
        resourceId: resource.id, recordId: record.id, actionName: 'show',
      });
      return (
        <Link to={href}>{`length: ${values.length}`}</Link>
      );
    }

    return (
      <span>{`length: ${values.length}`}</span>
    );
  }
}
